export const genericError = 'We ran into an unexpected issue while completing your request. Please try again. If the problem continues, contact your system administrator.'
export const couldNotFindRecordToDelete = 'Unable to delete record. Record not found'
